import { motion } from 'motion/react';

interface MetricCardProps {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  trend?: number; // percentage change
  color?: string;
}

export function MetricCard({ title, value, icon, trend, color = '#6366f1' }: MetricCardProps) {
  const formattedValue = typeof value === 'number'
    ? value >= 1000000 ? `${(value / 1000000).toFixed(1)}M`
    : value >= 1000 ? `${(value / 1000).toFixed(1)}K`
    : value.toString()
    : value;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-2xl p-4 sm:p-5"
      style={{
        background: 'rgba(255,255,255,0.7)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(148,163,184,0.2)',
      }}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-slate-500 uppercase tracking-wider">{title}</span>
        <span style={{ color }} className="opacity-60">{icon}</span>
      </div>
      <div className="flex items-end gap-2">
        <span className="text-2xl sm:text-3xl font-bold text-slate-900">{formattedValue}</span>
        {trend !== undefined && (
          <span className={`text-xs font-semibold mb-1 ${trend >= 0 ? 'text-emerald-500' : 'text-red-500'}`}>
            {trend >= 0 ? '+' : ''}{trend.toFixed(1)}%
          </span>
        )}
      </div>
    </motion.div>
  );
}
